// Extended service details for detail pages
export const serviceDetails = {
  1: {
    id: 1,
    slug: "infrastructure-data-center-cloud",
    title: "Infrastructure, Data Center & Cloud",
    heroImage: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1600&q=80",
    overview: "Transformasi infrasuktur IT modern yang komprehensif untuk meningkatkan efesiensi operasional dan skalabilitas Anda. Kami menyediakan solusi end-to-end dari desain hingga implementasi.",
    overviewEn: "Comprehensive modern IT infrastructure transformation to enhance your operational efficiency and scalability. We provide end-to-end solutions, from design to seamless implementation",
    mainFeatures: [
      {
        title: "Desain & Konstruksi Data Center",
        description: "Merancang dan membangun data center dengan standar internasional Tier III/IV",
        details: [
          "Arsitektur fisik optimal dengan redundancy N+1 atau 2N",
          "Sistem keamanan fisik 24/7 dengan biometric access control",
          "Optimasi efisiensi energi dengan PUE < 1.5",
          "Sistem pendingin precision cooling dengan hot/cold aisle containment",
          "Fire suppression system dengan FM-200 atau Novec 1230",
          "UPS dan generator backup untuk 99.99% uptime"
        ]
      },
      {
        title: "Modernisasi Infrastruktur IT",
        description: "Upgrade infrastruktur legacy ke teknologi modern dan efisien",
        details: [
          "Server consolidation dengan virtualization (VMware, Hyper-V, KVM)",
          "Migrasi ke modern storage (All-Flash Array, NVMe)",
          "Implementasi Hyperconverged Infrastructure (HCI) - Nutanix, VMware vSAN",
          "Network infrastructure upgrade (SDN, SD-WAN)",
          "Disaster Recovery Planning & Implementation",
          "Performance monitoring & optimization"
        ]
      },
      {
        title: "Solusi Hybrid & Multi-Cloud",
        description: "Integrasi seamless antara on-premise dan multiple cloud providers",
        details: [
          "Cloud integration (AWS, Azure, Google Cloud, Alibaba Cloud)",
          "Centralized multi-cloud management dengan single pane of glass",
          "Container orchestration dengan Kubernetes",
          "Workload mobility & cloud bursting",
          "Cost optimization & FinOps implementation",
          "Cloud-native application development"
        ]
      }
    ],
    benefits: [
      "Peningkatan uptime hingga 99.99%",
      "Pengurangan operational cost hingga 40%",
      "Skalabilitas infrastruktur sesuai pertumbuhan bisnis",
      "Disaster recovery dengan RTO < 4 jam",
      "Compliance dengan standar internasional (ISO 27001, PCI-DSS)"
    ],
    technologies: ["VMware", "Nutanix", "Dell EMC", "HPE", "Cisco", "Juniper", "AWS", "Azure", "Google Cloud"],
    caseStudies: [
      {
        client: "Kementerian PUPR",
        challenge: "Legacy infrastructure dengan frequent downtime",
        solution: "Modernisasi dengan HCI dan hybrid cloud",
        result: "99.9% uptime, 35% cost reduction"
      }
    ]
  },
  2: {
    id: 2,
    slug: "cyber-security-solution",
    title: "Cyber Security Solution",
    heroImage: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=1600&q=80",
    overview: "Perlindungan komprehensif berlapis untuk mengamankan aset digital, data, dan sistem IT dari ancaman cyber yang semakin kompleks. Kami mengimplementasikan best practice security framework dengan teknologi terdepan.",
    overviewEn: "Comprehensive, layered protection to secure digital assets, data, and IT systems from increasingly complex cyber threats. We implement security framework best practices with leading technology.",
    mainFeatures: [
      {
        title: "Keamanan Jaringan & Monitoring 24/7",
        description: "Proteksi perimeter dan monitoring real-time untuk deteksi & response ancaman",
        details: [
          "Next-Generation Firewall (NGFW) - Palo Alto, Fortinet, Sophos",
          "Intrusion Prevention System (IPS) dengan signature & behavioral analysis",
          "Security Operations Center (SOC) 24/7 dengan certified analysts",
          "SIEM (Security Information & Event Management) - Splunk, QRadar",
          "Real-time threat intelligence integration",
          "Managed Detection & Response (MDR) service",
          "Network segmentation & micro-segmentation",
          "Web Application Firewall (WAF) untuk aplikasi web"
        ]
      },
      {
        title: "Perlindungan Endpoint & Data",
        description: "Keamanan untuk seluruh endpoint dan data sensitif perusahaan",
        details: [
          "Endpoint Detection & Response (EDR) - CrowdStrike, SentinelOne",
          "Data Loss Prevention (DLP) untuk mencegah kebocoran data",
          "Email security dengan anti-phishing & malware protection",
          "Encryption untuk data at-rest dan in-transit",
          "Multi-Factor Authentication (MFA) implementation",
          "Vulnerability management & patch management",
          "Automated patching untuk OS dan aplikasi",
          "Mobile Device Management (MDM) untuk BYOD policy"
        ]
      },
      {
        title: "Manajemen Insiden & Pemulihan",
        description: "Response cepat dan recovery plan untuk incident security",
        details: [
          "Incident Response Team (IRT) 24/7 on-call",
          "Digital forensics & investigation capability",
          "Ransomware protection dengan backup immutable",
          "Ransomware recovery dengan RTO < 24 jam",
          "Business Continuity Planning (BCP)",
          "Disaster Recovery Planning (DRP)",
          "Regular security incident simulation & tabletop exercise",
          "Post-incident analysis & remediation"
        ]
      },
      {
        title: "Layanan Keamanan Terkelola",
        description: "Managed security services untuk continuous protection",
        details: [
          "Security assessment & vulnerability scanning",
          "Penetration testing (internal & external)",
          "Compliance audit (ISO 27001, PCI-DSS, GDPR)",
          "Security awareness training untuk karyawan",
          "Managed vulnerability management",
          "Proactive threat hunting",
          "Security policy development & review",
          "Vendor security assessment"
        ]
      }
    ],
    benefits: [
      "Proteksi 24/7 terhadap serangan cyber",
      "Compliance dengan regulasi internasional",
      "Pengurangan risiko data breach hingga 90%",
      "Faster incident response time < 15 menit",
      "Audit trail lengkap untuk forensik"
    ],
    technologies: ["Palo Alto Networks", "Fortinet", "Sophos", "CrowdStrike", "SentinelOne", "Splunk", "Microsoft Defender"],
    caseStudies: [
      {
        client: "Bank Indonesia",
        challenge: "Sophisticated cyber attacks & compliance requirements",
        solution: "Comprehensive security stack dengan SOC 24/7",
        result: "Zero successful breaches, ISO 27001 certified"
      }
    ]
  },
  3: {
    id: 3,
    slug: "geospatial-technology",
    title: "GeoSpatial Technology",
    heroImage: "https://images.unsplash.com/photo-1736117703416-f260ee174bac?auto=format&fit=crop&w=1600&q=80",
    overview: "Solusi geospasial untuk analisis data spasial, perencanaan strategis, dan pengambilan keputusan berbasis lokasi. Teknologi GIS dan remote sensing untuk berbagai sektor pemerintahan dan swasta.",
    overviewEn: "Geospatial solutions for spatial data analysis, strategic planning, and location-based decision making. GIS and remote sensing technology for various government and private sectors.",
    mainFeatures: [
      {
        title: "Optimalisasi PAD melalui Sinkronisasi NIB-NOP",
        description: "Integrasi data untuk meningkatkan akurasi pajak dan retribusi daerah",
        details: [
          "Integrasi Nomor Induk Berusaha (NIB) dengan Nomor Objek Pajak (NOP)",
          "Spatial analysis untuk identifikasi objek pajak tidak terdaftar",
          "Automated data validation & cleansing",
          "Increased accuracy dalam data pajak & retribusi daerah",
          "Compliance enforcement support dengan geo-verification",
          "Dashboard analytics untuk monitoring PAD real-time",
          "Mobile application untuk surveyor lapangan",
          "Reporting & analytics untuk tax gap analysis"
        ]
      },
      {
        title: "Analisis Perubahan Lahan",
        description: "Monitoring dan analisis perubahan penggunaan lahan untuk perencanaan",
        details: [
          "Land use & land cover change detection",
          "Satellite imagery analysis (Landsat, Sentinel, SPOT)",
          "Time-series analysis untuk trend monitoring",
          "Sustainable city planning dengan spatial modeling",
          "Disaster-prone area identification",
          "Environmental impact assessment",
          "Urban growth modeling & simulation",
          "Agricultural land monitoring"
        ]
      },
      {
        title: "Analisis Kependudukan",
        description: "Spatial population analytics untuk kebijakan sosial",
        details: [
          "Spatial population data analysis & visualization",
          "Demographic profiling dengan geolocation",
          "Social assistance survey support dengan mobile GIS",
          "Effective social policy formulation berbasis data",
          "Population density mapping",
          "Migration pattern analysis",
          "Public facility accessibility analysis",
          "Health & education facility planning"
        ]
      }
    ],
    benefits: [
      "Peningkatan PAD hingga 30% melalui tax gap closure",
      "Data-driven decision making untuk kebijakan",
      "Monitoring perubahan lahan secara real-time",
      "Efisiensi survey lapangan dengan mobile GIS",
      "Better public service delivery"
    ],
    technologies: ["ArcGIS", "QGIS", "Google Earth Engine", "PostgreSQL/PostGIS", "Mapbox", "Leaflet"],
    caseStudies: [
      {
        client: "Pemda DKI Jakarta",
        challenge: "Inaccurate tax data & illegal land use",
        solution: "GIS-based tax management system",
        result: "25% increase in PAD, 90% data accuracy"
      }
    ]
  },
  4: {
    id: 4,
    slug: "database-management",
    title: "Database Management",
    heroImage: "https://images.unsplash.com/photo-1642775196125-38a9eb496568?auto=format&fit=crop&w=1600&q=80",
    overview: "Solusi database komprehensif untuk performa optimal, high availability, dan disaster recovery. Kami mengelola berbagai jenis database mulai dari relational hingga NoSQL untuk berbagai use case.",
    overviewEn: "Comprehensive database solutions for optimal performance, high availability, and disaster recovery. We manage various types of databases, from relational to NoSQL, for a wide range of use cases.",
    mainFeatures: [
      {
        title: "Solusi Database Komprehensif",
        description: "End-to-end database management services",
        details: [
          "Seamless database migration tanpa downtime",
          "Database performance tuning & optimization",
          "Query optimization untuk faster response time",
          "Hybrid & multi-cloud architecture untuk flexibility & scalability",
          "Database as a Service (DBaaS) implementation",
          "High Availability dengan clustering & replication",
          "Automated failover dengan RTO < 5 menit",
          "Backup & recovery strategy dengan multiple retention policies"
        ]
      },
      {
        title: "Solusi Database Terintegrasi",
        description: "Modernisasi infrastruktur database",
        details: [
          "Server & storage modernization untuk database workload",
          "Hybrid & multi-cloud architecture (on-prem + cloud)",
          "Centralized & distributed data management",
          "Data replication across multiple regions",
          "Database consolidation untuk cost efficiency",
          "Containerized database deployment dengan Kubernetes",
          "Microservices database pattern implementation",
          "Database virtualization"
        ]
      },
      {
        title: "Alat Manajemen Database Cerdas",
        description: "Tools & automation untuk meningkatkan produktivitas DBA",
        details: [
          "Integrated management features - monitoring, security, tuning",
          "Automated health check & diagnostics",
          "Performance monitoring dengan real-time dashboard",
          "Increased DBA & developer productivity dengan automation",
          "AI-based recommendations & optimization suggestions",
          "Automated index tuning & query optimization",
          "Capacity planning dengan predictive analytics",
          "Security compliance monitoring & audit"
        ]
      }
    ],
    benefits: [
      "Database uptime 99.99% dengan HA clustering",
      "Performance improvement hingga 300%",
      "Automated backup & recovery",
      "Cost optimization dengan right-sizing",
      "Simplified management dengan automation"
    ],
    technologies: ["Oracle", "Microsoft SQL Server", "PostgreSQL", "MySQL", "MongoDB", "Redis", "Cassandra"],
    caseStudies: [
      {
        client: "PT Telkom Indonesia",
        challenge: "Database performance bottleneck & frequent outages",
        solution: "Database optimization & HA implementation",
        result: "300% performance improvement, 99.99% uptime"
      }
    ]
  }
};


